import React from "react";

const Input = ({ name, label, error, ...rest }) => {
  return (
    <div className="mb-3">
      <label for={name} className="form-label">
        {label}
      </label>
      <input
        {...rest}
        name={name}
        className="form-control"
        id={name}
        aria-describedby="emailHelp"
      />
      {error && <div className="alert alert-danger my-2">{error}</div>}
    </div>
  );
};

export default Input;
